import React, { useState, useEffect, useContext } from 'react';
import { Input, InputGroup, Dropdown, InputGroupText, DropdownMenu, DropdownItem, Spinner } from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";
import { PlayerDataContext } from '../App.js';

const SearchBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [query, setQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const playerData = useContext(PlayerDataContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  
  const handleInputChange = (event) => {
    if(!dropdownOpen) {
      setDropdownOpen(true);
    }
    const query = event.target.value;
    setQuery(query);
  };

  useEffect(() => {
    if (location.pathname !== '/') {
      setQuery('');
    }
  }, [location.pathname]);

  useEffect(() => {
    const filteredData = playerData?.filter((item) => {
        return item.toLowerCase().includes(query.toLowerCase());
    }).slice(0, 15);
    setFilteredData(filteredData);
    }, [query, playerData]);

  const handleSelect = (selectedItem) => {
    setQuery(selectedItem);
    const path = `/player/${encodeURIComponent(selectedItem)}`;
    navigate(path);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <InputGroup>
      <Input
          type="text"
          placeholder="Enter a player name..."
          value={query}
          onChange={handleInputChange}
          className="search-input"
          style={{width: '25vw'}}
      />
      <InputGroupText className="search-input">Search</InputGroupText>
      {query?.length > 0 ? (
          <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} direction="down" className="dropdown-menu">
            <DropdownMenu>
                {!playerData ? <Spinner size="sm" color="light" style={{marginLeft: '1rem'}} /> : 
                  filteredData?.length > 0 ?
                    filteredData?.map((item, index) => (
                      <DropdownItem className="search-item" key={index} onClick={() => handleSelect(item)}>
                          {item}
                      </DropdownItem>
                    )) : <code style={{paddingLeft: '1rem'}}>No Players Found</code>
                }
            </DropdownMenu>
          </Dropdown>
      ) : null}
    </InputGroup>
  );
};

export default SearchBar;